import { z } from "zod";

const cidrRegex = /^\d{1,3}(\.\d{1,3}){3}\/\d{1,2}$/;
const ipRegex = /^\d{1,3}(\.\d{1,3}){3}$/;

export const redCreateSchema = z
  .object({
    nombre: z.string().min(1).max(100),
    descripcion: z.string().optional().or(z.literal("")),
    cidr: z.string().regex(cidrRegex, "Formato inválido (ej. 192.168.100.0/24)"),
    gateway: z.string().regex(ipRegex, "IP inválida").optional().or(z.literal("")),
    dns_primario: z.string().regex(ipRegex, "IP inválida").optional().or(z.literal("")),
    dns_secundario: z.string().regex(ipRegex, "IP inválida").optional().or(z.literal("")),
    vlan_id: z.union([z.coerce.number().int().min(1).max(4094), z.literal("")]).optional(),
    pool_start: z.string().regex(ipRegex, "IP inválida").optional().or(z.literal("")),
    pool_end: z.string().regex(ipRegex, "IP inválida").optional().or(z.literal("")),
    uso_interno: z.boolean().default(false),
    router_id: z.string().uuid().optional().or(z.literal("")),
    tags: z.array(z.string()).default([]),
  });

export const redUpdateSchema = redCreateSchema.partial().extend({
  activo: z.boolean().optional(),
});

export type RedCreateInput = z.infer<typeof redCreateSchema>;
export type RedUpdateInput = z.infer<typeof redUpdateSchema>;

export type RouterLink = { id: string; nombre: string };

export type RedSummary = {
  id: string;
  nombre: string;
  cidr: string;
  gateway: string | null;
  vlan_id: number | null;
  uso_interno: boolean;
  activo: boolean;
  router_id: string | null;
  router: RouterLink | null;
  created_at: string;
};

export type IPReservadaOut = {
  id: string;
  ip: string;
  descripcion: string | null;
  created_at: string;
};

export type RedDetail = RedSummary & {
  descripcion: string | null;
  dns_primario: string | null;
  dns_secundario: string | null;
  pool_start: string | null;
  pool_end: string | null;
  tags: string[];
  ips_reservadas: IPReservadaOut[];
  total_pool: number;
  total_reservadas: number;
};

export type PagedRedes = {
  items: RedSummary[];
  total: number;
  page: number;
  size: number;
  pages: number;
};

export const ipReservadaSchema = z.object({
  ip: z.string().regex(ipRegex, "IP inválida"),
  descripcion: z.string().max(200).optional().or(z.literal("")),
});
export type IPReservadaInput = z.infer<typeof ipReservadaSchema>;
